// AI-CONTEXT: See docs/test-runs/2026-10-21-rapportages-titel-kopie-deelnemer.md (B6)
import { storedDateToDay } from '../../utils/storedDate'

const pad = (n) => String(n).padStart(2, '0')

/**
 * Kenmerk achter de naam in een keuzelijst van deelnemers, zodat twee mensen
 * met dezelfde naam uit elkaar te houden zijn. Alleen de ingevulde `StartDate`
 * telt: `Timestamp` wordt bij elke bewerking overschreven en is dus geen
 * startmoment.
 *
 * @param {{Status?: string, StartDate?: *}} persona
 * @param {{[status: string]: string}} statusLabels - Statuswoorden van de organisatie
 * @returns {string} Bijv. 'Actief · start 03-02-2026'; leeg als er niets bekend is
 */
const personaOptionDetail = (persona, statusLabels) => {
    const statusLabel = statusLabels?.[persona?.Status || 'active']
    const start = storedDateToDay(persona?.StartDate)
    const startText = start
        ? `start ${pad(start.getDate())}-${pad(start.getMonth() + 1)}-${start.getFullYear()}`
        : ''
    return [statusLabel, startText].filter(Boolean).join(' · ')
}

export default personaOptionDetail
